import { s, c, nextAppRouter } from '../../../val.config';
import allEmployeesVal from '../../../data/employees.val';
import positionDetailsVal from './[slug]/page.val';
import {
  singleMediaElementSchema,
  doubleMediaElementSchema,
  imageCarouselElementSchema,
  linksElementSchema,
  textElementSchema,
  textAndImageElementSchema,
  socialCalendar,
} from '../../../schema/pageElements.val';
import { pageMetadataSchema } from '../../../schema/pageMetadata.val';

export const schema = s.object({
  subheader: s.string(),
  header: s.string(),
  pageImage: s.image(),
  ingress: s.richtext({
    bold: true,
    italic: true,
    lineThrough: true,
    h1: false,
    h2: false,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    ul: true,
    ol: true,
    a: true,
    img: true,
  }),
  availablePositions: s.array(
    s.object({
      title: s.string(),
      active: s.boolean(),
      description: s.string(),
      positionSlug: s.keyOf(positionDetailsVal),
    })
  ),
  pageElements: s.array(
    s.union(
      'type',
      singleMediaElementSchema,
      doubleMediaElementSchema,
      textElementSchema,
      textAndImageElementSchema,
      linksElementSchema,
      imageCarouselElementSchema,
      socialCalendar
    )
  ),
  contact: s.object({
    title: s.string(),
    link: s.object({
      text: s.string(),
      href: s.string(),
    }),
    persons: s.array(s.keyOf(allEmployeesVal)),
  }),
  pageMetadata: pageMetadataSchema,
});

export default c.define(
  '/app/(main)/jobb/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/jobb': {
      header: 'Jobb i Blank',
      subheader: 'Bli en del av Blank',
      pageImage: {
        path: '/public/val/nye_22_cropped_01b8f.jpg',
        width: 1999,
        height: 1108,
        mimeType: 'image/jpeg',
        alt: 'Blank ansatte',
        hotspot: { x: 0.5464110393864466, y: 0.23416869455295153 },
      },
      ingress: [
        {
          tag: 'p',
          children: [
            'Du vet den følelsen av å jobbe med flinke folk, lage skikkelige ting og faktisk ha det bra på jobb? Det er den følelsen vi bygger Blank rundt. ',
            { tag: 'br' },
            { tag: 'br' },
            'Vi ser alltid etter flere som vil være med.',
          ],
        },
      ],
      pageElements: [
        {
          type: 'imageCarouselElement',
          images: [
            {
              path: '/public/val/kontor_mira_f9b97.jpg',
              width: 2000,
              height: 3000,
              mimeType: 'image/jpeg',
              alt: 'Mira jobber',
            },
            {
              path: '/public/val/kontor_max_d1e7c.jpg',
              width: 2000,
              height: 3000,
              mimeType: 'image/jpeg',
              alt: 'Max jobber',
            },
            {
              path: '/public/val/kontor_mathilde_syndey_1fbb5.jpg',
              width: 2000,
              height: 2667,
              mimeType: 'image/jpeg',
              alt: 'Mathilde koser med hund',
            },
            {
              path: '/public/val/kontor_filip_c28ca.jpg',
              width: 2000,
              height: 3000,
              mimeType: 'image/jpeg',
              alt: 'F',
            },
            {
              path: '/public/val/kontor_astri_jon_09db1.jpg',
              width: 2000,
              height: 3001,
              mimeType: 'image/jpeg',
              alt: 'A',
            },
            {
              path: '/public/val/kontor_bendik_sandra_6869d.jpg',
              width: 2000,
              height: 3000,
              mimeType: 'image/jpeg',
              alt: 'Kaffepause',
            },
            {
              path: '/public/val/kontor_neva_518a7.jpg',
              width: 2000,
              height: 2667,
              mimeType: 'image/jpeg',
              alt: 'Neva jobber',
            },
            {
              path: '/public/val/kontor_bendik_neva_759ca.jpg',
              width: 2000,
              height: 2667,
              mimeType: 'image/jpeg',
              alt: 'B',
            },
          ],
        },
        {
          type: 'textElement',
          title: 'Som ansatt i Blank får du',
          text: [
            {
              tag: 'ul',
              children: [
                {
                  tag: 'li',
                  children: [
                    {
                      tag: 'p',
                      children: [
                        'Utfordrende oppdrag som løser viktige problemer',
                      ],
                    },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    {
                      tag: 'p',
                      children: ['Sterkt fagmiljø med skikkelig dyktige folk'],
                    },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    {
                      tag: 'p',
                      children: ['Godt arbeidsmiljø der folk bryr seg om deg'],
                    },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    { tag: 'p', children: ['Tenke og bestemme ting selv'] },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    {
                      tag: 'p',
                      children: ['Høy og fastlønn i en åpen modell'],
                    },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    { tag: 'p', children: ['Alltid fri mellom jul og nyttår'] },
                  ],
                },
                {
                  tag: 'li',
                  children: [
                    {
                      tag: 'p',
                      children: ['Mulighet til å eie Blank sammen med oss'],
                    },
                  ],
                },
              ],
            },
          ],
        },
        { type: 'socialCalendar' },
        {
          type: 'linksElement',
          links: [
            { text: 'Utforsk hva vi jobber med', href: '/arbeider' },
            { text: 'Les om hvordan vi jobber', href: '/om-oss' },
            { text: 'Ta en kikk på håndboka', href: '/handboka' },
          ],
        },
      ],
      availablePositions: [
        {
          description: `Bli teknolog i Blank!`,
          positionSlug: '/jobb/teknolog',
          title: 'Erfaren teknolog',
          active: true,
        },
        {
          title: 'Nyutdannet teknolog',
          active: false,
          description: 'Blank søker nyutdannede teknologer for oppstart i 2026',
          positionSlug: '/jobb/nyutdannet-teknolog',
        },
        {
          description: 'Bli designer i Blank!',
          positionSlug: '/jobb/designer',
          title: 'Erfaren designer',
          active: true,
        },
        {
          title: 'Nyutdannet designer',
          active: false,
          description: 'Blank søker nyutdannede designere for oppstart i 2026',
          positionSlug: '/jobb/nyutdannet-designer',
        },
        {
          title: 'Vårjobb for studenter',
          active: false,
          description: 'Deltidsjobb for studenter våren 2025',
          positionSlug: '/jobb/student',
        },
        {
          title: 'Nyutdannet designer',
          active: false,
          description: 'Søk nå',
          positionSlug: '/jobb/nyutdannet-designer',
        },
      ],
      pageMetadata: {
        title: 'Jobb i Blank',
        description: 'Jobb i Blank',
        image: {
          path: '/public/val/images/dbcb029cf591f7424afeba3f21cbf7f641e704ba-3500x2333.webp',
          width: 3500,
          height: 2333,
          mimeType: 'image/webp',
          alt: 'Fest på loftet',
        },
      },
      contact: {
        title: 'Har du spørsmål om jobb i Blank?',
        link: {
          text: 'Ta kontakt for en hyggelig prat',
          href: '/kaffeprat',
        },
        persons: ['magne', 'bernholdt', 'Lena Andersen'],
      },
    },
  }
);
